import { render, staticRenderFns } from "./LinkPreviewMini.vue?vue&type=template&id=2a55e7de&"
import script from "./LinkPreviewMini.vue?vue&type=script&lang=js&"
export * from "./LinkPreviewMini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports